export class ObjectUtils {

    static isNullOrEmpty(obj: any) {
        return !obj || Object.keys(obj).length === 0;
    }

}